(function () {
  const html = document.documentElement;

  /**
   * Function to open modal
   *
   * @param {string} modalId - The id of the modal to open
   */
  function openModal(modalId) {
    document.getElementById(modalId).classList.add("is-open");
    html.classList.add("no-scroll");
  }

  /**
   * Function to close modal
   *
   * @param {string} modalId - The id of the modal to close
   */
  function closeModal(modalId) {
    document.getElementById(modalId).classList.remove("is-open");
    html.classList.remove("no-scroll");
  }

  /**
   * Function to handle click on modal button
   *
   * @param {Event} e - The click event
   * @param {HTMLElement} btn - The button clicked
   */
  const handleClick = (e, btn) => {
    e.preventDefault();
    const modalId = btn.getAttribute("data-modal");
    openModal(modalId);

    // GTM Tracking
    if (typeof gtm_datalayer_push === "function") {
      let pageViewData = {
        path: `/${btn.getAttribute("data-section")}/${btn.getAttribute("data-title")}`,
        section: btn.getAttribute("data-section"),
      };
      if (btn.hasAttribute("data-continent") && btn.getAttribute("data-continent")) {
        pageViewData.continent = btn.getAttribute("data-continent");
      }
      if (btn.hasAttribute("data-country") && btn.getAttribute("data-country")) {
        pageViewData.country = btn.getAttribute("data-country");
      }
      if (btn.hasAttribute("data-trip-type") && btn.getAttribute("data-trip-type")) {
        pageViewData.tripType = btn.getAttribute("data-trip-type");
      }
      gtm_datalayer_push(
        {
          event: "page_view",
          page: pageViewData,
        },
        true,
      );
    }
  };

  document.querySelectorAll(".js-modal").forEach(function (modal) {
    if (modal) {
      // Close Modal on close button click
      const closeButton = modal.querySelector(".js-modal-close");
      closeButton.addEventListener("click", () => closeModal(modal.id));

      // Close Modal on overlay click
      const overlay = modal.querySelector(".ux-backdrop");
      if (overlay) {
        overlay.addEventListener("click", () => closeModal(modal.id));
      }
    }
  });

  // Open modal on click
  const modalButtons = document.querySelectorAll(".js-modal-button[data-modal]");
  modalButtons.forEach((modalButton) => {
    modalButton.addEventListener("click", (e) => {
      handleClick(e, modalButton);
    });
  });
})();
